<div class="modal fade" bsModal #staticModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
  aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-sm" style="width: 400px;">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-events-name" class="modal-title pull-left">Service Provider Logo</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="closeLogoUpload()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <input id="fileuploader" name="files[0]" accept="image/*" style="margin:15px;" type="file"
          (change)="onFileChanged($event)" value="Choose Image" />
        <div *ngIf="serviceProviderLogo!=null" class="text-center">
          <img id="uploadPreview" alt="selected account logo" style="max-height: 100px;max-width: 300px;" />
          <button class="btn btn-block btn-info btn-sm" style="margin-top:10px;" (click)="uploadFile()">
            <i class="fa fa-cloud-upload" style="margin-right:5px;"></i>Upload</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card-header">
  <span [ngSwitch]="listing">
    <span *ngSwitchCase="false">Add/Update Service Provider</span>
    <span *ngSwitchCase="true">Existing Service Providers</span>
  </span>
  <button class="btn btn-sm btn-warning float-right"
    style="font-size: 14px;margin-top: -4px; background-color:  rgb(87,200,231);color: #ffffff;height:38px;"
    (click)="toggleView()">
    <span *ngIf="listing" tooltip="Click here to add new service provider">
      <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> New Service Provider</span>
    <span *ngIf="!listing">
      <i class="fa fa-arrow-left" style="margin-top:6px;color:#fff;"></i> Back</span>
  </button>
</div>

<div class="content-body padding-top-20 padding-bottom-20">
  <div class="row">
    <div *ngIf="listing; then tableTemplate; else wizardTemplate;">
    </div>
    <ng-template #tableTemplate>
      
            <p-table 
            [value]="serviceProviders"
            [lazy]="true"
            (onLazyLoad)="onPageChange($event)"
            [paginator]="serviceProviders != null && serviceProviders.length > 0"
            [rows]="rows"
            [first]="paging.currentPage"
            [totalRecords]="totalRecords"
            #dt
              >
            <ng-template pTemplate="header">
          <tr style="height : 65px;">
            <th style="width:100px;text-align: center;">#
            </th>
            <th>Provider
            </th>
            <th>Type
            </th>
            <th>Contact Information
            </th>
            <th>Address
            </th>
            <th>Associated accounts
            </th>
            <th>Logo
            </th>
          </tr>

          <tr 
            style="font-family:Arial, FontAwesome;text-align: center;">
            <td class="primeng-table-search">
              <!-- <input class="primeng-table-search-field" disabled pInputText type="search"
                (input)="dt.filter($event.target.value, 'name', 'contains')"> -->
            </td>
            <td class="primeng-table-search">
              <input class="primeng-table-search-field search-bar-true" placeholder=" &#xf002;  Provider name"
                pInputText type="text" (input)="onSearch($event.target.value,'name')">
            </td>
            <td class="primeng-table-search">
              <!-- <input class="primeng-table-search-field" disabled pInputText type="search"
                (input)="dt.filter($event.target.value, 'type', 'contains')"> -->
            </td>
            <td class="primeng-table-search">
              <input class="primeng-table-search-field search-bar-true" placeholder=" &#xf002;  E-mail" pInputText
                type="text" (input)="onSearch($event.target.value,'email')">
            </td>
            <td class="primeng-table-search">
              <!-- <input class="primeng-table-search-field" disabled pInputText type="search"
                (input)="dt.filter($event.target.value, 'address', 'contains')"> -->
            </td>
            <td class="primeng-table-search">
              <!-- <input class="primeng-table-search-field" disabled pInputText type="search"
                (input)="dt.filter($event.target.value, 'name', 'contains')"> -->
            </td>
            <td class="primeng-table-search">
              <!-- <input class="primeng-table-search-field" disabled pInputText type="search"
                (input)="dt.filter($event.target.value, 'name', 'contains')"> -->
            </td>
          </tr>
          <tr *ngIf="serviceProviders==null || serviceProviders.length==0"
          style="border-left: 1px solid #f4f4f4;border-right: 1px solid #f4f4f4;border-bottom: 1px solid #f4f4f4;">
          <td colspan="6">
            <div style="padding: 5px;text-align: center;">
              No record found
            </div>
          </td>
        </tr>
        </ng-template>
        <ng-template pTemplate="body" let-serviceProvider let-i="rowIndex">
          <tr class="table-striped" style="cursor: pointer;">
            <td style="text-align: center;" (click)="editServiceProviderInfo(serviceProvider)">{{i + 1}}</td>
            <td (click)="editServiceProviderInfo(serviceProvider)">{{serviceProvider.name}}</td>
            <td>{{getProviderType(serviceProvider.type)}}</td>
            <td (click)="editServiceProviderInfo(serviceProvider)" style="word-break: break-all;">
              {{serviceProvider.email}}
              <br> {{serviceProvider.phone}}
            </td>
            <td (click)="editServiceProviderInfo(serviceProvider)">{{getAddressString(serviceProvider.address)}}
            </td>
            <td (click)="editServiceProviderInfo(serviceProvider)">
              <span *ngFor="let item of serviceProvider.accountIds; let isLast=last">
                {{getAccountName(item)}}{{isLast ? '' : ', '}}
              </span>
            </td>
            <td>
              <!-- <img (click)="updateServiceProviderLogo(serviceProvider)" src="{{serviceProvider.logo}}"
                style="max-height: 100px;" class="img-responsive" onerror="this.src='assets/images/no-logo.png'" /> -->
                 
              <img
                (click)="updateServiceProviderLogo(serviceProvider)"
                [src]="serviceProvider.logo? serviceProvider.logo : defaultLogo"
                (error)="setDefaultLogo($event)"
                class="img-responsive"
                style="max-height: 100px;"
              /> 
            
              </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-template>
    <ng-template #wizardTemplate>
      <aw-wizard #wizard [defaultStepIndex]="0" navBarLayout="large-filled-symbols">
        <aw-wizard-step awOptionalStep [stepId]="1" [stepTitle]="'Service Provider Info'"
          [navigationSymbol]="{ symbol: '1'}">
          <form #providerInfoForm="ngForm" class="mTop30">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label">Service Provider Name
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Service provider/Organisation Name</span>
                <div class="controls">
                  <input type="text" (keyup)="validateServiceProviderInfo('name')" class="form-control"  
                  pattern="^[a-zA-Z0-9&,-. ]*" id="serviceProviderName" name="serviceProviderName"
                    placeholder="Enter service provider name here..." #serviceProviderName="ngModel"
                    [(ngModel)]="serviceProviderInfo.name" required />
                    <div *ngIf="serviceProviderName.errors && serviceProviderName.dirty" class="danger-text">
                      <div *ngIf="serviceProviderName.errors.required">
                        Service Provider Name is required
                      </div>
                      <div *ngIf="serviceProviderName.errors.pattern">
                        Incorrect input, allowed alphanumerics and special chars (& , . -)
                      </div>
                      <div *ngIf="nameExists" class="danger-text">
                        Service provider name already exits
                      </div>
                    </div>

                  <!-- <div [hidden]="serviceProviderName.valid || serviceProviderName.pristine" class="danger-text">
                    Service provider Name is required
                  </div> -->
                  
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label">Service Provider Type
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Service provider type</span>
                <div class="controls">
                  <select [(ngModel)]="serviceProviderInfo.type" (change)="onProviderTypeChange($event.target.value)"
                    required class="form-select form-select-sm" #providerCategory="ngModel" id="providerCategory"
                    name="providerCategory">
                    <option *ngFor="let category of serviceProviderCategories | orderBy:'categoryName'"
                      [ngValue]="category.categoryId">{{category.categoryName}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div class=" form-group">
                <label class="form-label">Accounts to be associated
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Accounts to be associated with</span>
                <div class="controls">
                  <!--<angular2-multiselect class="form-control" [data]="accounts" name="availableAccounts"
                    #availableAccounts="ngModel" [settings]="{ enableSearchFilter: true}"
                    [(ngModel)]="serviceProviderInfo.accountIds">
                  </angular2-multiselect>-->
                  <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="accounts" name="availableAccounts"
                    #availableAccounts="ngModel" [(ngModel)]="serviceProviderInfo.accountIds">
                  </ng-multiselect-dropdown>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" *ngIf="serviceProviderInfo.type == 'SERVICE_AI'">
              <div class=" form-group">
                <label class="form-label">Workflow
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">AI Provider Workflow</span>
                <div class="controls">
                  <!--<angular2-multiselect class="form-control" [data]="AIWorkflows" name="availableAIFlows"
                    #availableAIFlows="ngModel" [settings]="{ enableSearchFilter: true}"
                    [(ngModel)]="serviceProviderInfo.aiMode">
                  </angular2-multiselect>-->
                  <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="AIWorkflows" name="availableAIFlows"
                    #availableAIFlows="ngModel" [(ngModel)]="serviceProviderInfo.aiMode">
                  </ng-multiselect-dropdown>
                </div>
              </div>
            </div>
            <!-- <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" *ngIf="serviceProviderInfo.type == 'SERVICE_AI'">
                    <div class=" form-group">
                      <label class="form-label">Is Grading Available
                        <span class="mandatory-symbol">*</span>
                      </label>
                      <span class="desc"></span>
                      <div class="controls">
                        <div class="chiller_cb">
                          <div class="chiller_cb">
                            <input id="isGrading" [(ngModel)]="serviceProviderInfo.imageGrading " name="isGrading" type="checkbox" />
                            <label style="font-weight: normal;" for="isGrading">Select if grading feature available(seperate  API for grading)</label>
                            <span></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
              <div class=" form-group">
                <label class="form-label" for="field-1">Contact Email
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Email for communication with service provider</span>
                <div class="controls">
                  <input type="email" (keyup)="validateServiceProviderInfo('email')" name="email" id="email"
                    pattern="[a-zA-Z0-9_.+\-]{1,}@[a-zA-Z.-]{2,}\.[a-zA-Z]{2,}" #email="ngModel"
                    [(ngModel)]="serviceProviderInfo.email" class="form-control"
                    placeholder="Enter email address here..." required />
                  <div *ngIf="email.errors && email.dirty" class="danger-text">
                    <div *ngIf="email.errors.required">
                      Email is required
                    </div>
                    <div *ngIf="email.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div>
                  <div *ngIf="emailExists" class="danger-text">
                    Service provider Email already exits
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label" for="field-1">Contact Mobile
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Mobile for communication with service provider</span>
                <div class="controls">
                  <input type="text" (keyup)="validateServiceProviderInfo('mobile')" (keypress)="_keyPress($event)"
                    [(ngModel)]="serviceProviderInfo.phone" ng-pattern="/^[0-9]*$/" #mobile="ngModel" name="mobile"
                    id="mobile" class="form-control" placeholder="Enter mobile number here..." required />
                  <div [hidden]="mobile.valid || mobile.pristine" class="danger-text">
                    Mobile number is required
                  </div>
                  <div *ngIf="mobileExists" class="danger-text">
                    Service provider mobile number already exits
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
              <div class=" form-group">
                <label class="form-label" for="field-1">Address Line1
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Flat/Door/Block No</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="serviceProviderInfo.address.addressLine1" #addressLine1="ngModel"  
                  pattern=".*[a-zA-Z0-9].*" name="addressLine1" id="addressLine1" class="form-control" placeholder="Enter address line1 here..."
                    required />
                  <!-- <div [hidden]="addressLine1.valid || addressLine1.pristine" class="danger-text">
                    Address Line1 is required
                  </div> -->
                  <div *ngIf="addressLine1.errors && addressLine1.dirty" class="danger-text">
                    <div *ngIf="addressLine1.errors.required">
                      Address Line1 is required
                    </div>
                    <div *ngIf="addressLine1.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label" for="field-1">AddressLine 2
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Area/Locality</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="serviceProviderInfo.address.addressLine2" #addressLine2="ngModel"  
                  pattern=".*[a-zA-Z0-9].*" name="addressLine2" id="addressLine2" class="form-control" placeholder="Enter address line2 here..."
                    required />
                  <!-- <div [hidden]="addressLine2.valid || addressLine2.pristine" class="danger-text">
                    Address Line2 is required
                  </div> -->
                  <div *ngIf="addressLine2.errors && addressLine1.dirty" class="danger-text">
                    <div *ngIf="addressLine2.errors.required">
                      Address Line2 is required
                    </div>
                    <div *ngIf="addressLine2.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
              <div class=" form-group">
                <label class="form-label" for="field-1">District
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">District/City/Town</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="serviceProviderInfo.address.district" #district="ngModel" 
                  pattern=".*[a-zA-Z].*"  name="district" id="district" class="form-control" placeholder="Enter district here..." required />
                  <!-- <div [hidden]="district.valid || district.pristine" class="danger-text">
                    District is required
                  </div> -->
                  <div *ngIf="district.errors && district.dirty" class="danger-text">
                    <div *ngIf="district.errors.required">
                      District is required
                    </div>
                    <div *ngIf="district.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label" for="field-1">State
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">State</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="serviceProviderInfo.address.state" #state="ngModel" name="state"   
                  pattern="^[a-zA-Z ]*"  id="state" class="form-control" placeholder="Enter state here..." required />
                  <!-- <div [hidden]="state.valid || state.pristine" class="danger-text">
                    State is required
                  </div> -->
                  <div *ngIf="state.errors && state.dirty" class="danger-text">
                    <div *ngIf="state.errors.required">
                      State is required 
                    </div>
                    <div *ngIf="state.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
              <div class=" form-group">
                <label class="form-label" for="field-1">Pincode
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Pincode</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="serviceProviderInfo.address.zipcode" #pincode="ngModel" name="pincode" 
                  pattern="^[0-9 ]*"  id="pincode" class="form-control" placeholder="Enter pincode here..." required />
                  <!-- <div [hidden]="pincode.valid || pincode.pristine" class="danger-text">
                    Pincode is required
                  </div> -->
                  <div *ngIf="pincode.errors && pincode.dirty" class="danger-text">
                    <div *ngIf="pincode.errors.required">
                      Pincode is required
                    </div>
                    <div *ngIf="pincode.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label" for="field-1">Country
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Country</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="serviceProviderInfo.address.country" #country="ngModel" name="country"   
                  pattern="^[a-zA-Z ]*"  id="country" class="form-control" placeholder="Enter country here..." required />
                  <!-- <div [hidden]="country.valid || country.pristine" class="danger-text">
                    Country name is required
                  </div> -->
                  <div *ngIf="country.errors && country.dirty" class="danger-text">
                    <div *ngIf="country.errors.required">
                      Country is required 
                    </div>
                    <div *ngIf="country.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
              <div class=" form-group">
                <label class="form-label" for="field-1">Language
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Official/Communication language</span>
                <div class="controls">
                  <select [(ngModel)]="serviceProviderInfo.language" required class="form-select form-select-sm" #language="ngModel"
                    id="language" name="language">
                    <option *ngFor="let language of languageList" [ngValue]="language.alpha2">{{language.English}}
                    </option>
                  </select>
                </div>
              </div>
            </div>-->
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label">Languages
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">List of languages available for the users</span>
                <div class="controls">
                  <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="masterLanguageList"
                    (onSelect)="languageModified($event,'ADD')" (onDeSelect)="languageModified($event,'REMOVE')"
                    (onSelectAll)="languageModified($event,'ADD_ALL')"
                    (onDeSelectAll)="languageModified($event,'REMOVE_ALL')" name="masterLanguageList"
                    [(ngModel)]="selectedMasterLanguageList">
                  </ng-multiselect-dropdown>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"
              *ngIf="selectedMasterLanguageList!=null && selectedMasterLanguageList.length>0">
              <div class=" form-group">
                <label class="form-label">Default Language
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Default language for provider</span>
                <div class="controls">
                  <select [(ngModel)]="defaultLanguage" required class="form-select form-select-sm" #language="ngModel" id="language"
                    name="language">
                    <option [ngValue]="null">Select Default Language</option>
                    <option *ngFor="let language of defaultLanguageList" [ngValue]="language.id">{{language.itemName}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
              <div class=" form-group">
                <label class="form-label" for="field-1">Timezone
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc"></span>
                <div class="controls">
                  <select [(ngModel)]="serviceProviderInfo.timeZone" required class="form-select form-select-sm" #timezone="ngModel"
                    id="timezone" name="timezone">
                    <option *ngFor="let timezone of timeZoneList" [ngValue]="timezone.offset">{{timezone.text}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label" for="field-1">Date Format
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc"></span>
                <div class="controls">
                  <select [(ngModel)]="serviceProviderInfo.dateFormat" required class="form-select form-select-sm" #timezone="ngModel"
                    id="dateformat" name="dateformat">
                    <option *ngFor="let format of dateFormatList" [ngValue]="format">{{format}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label">Enable 2-Step Authentication</label>
                <span class="desc"></span>
                <div class="controls">
                  <div class="chiller_cb">
                    <input id="isLoginOTPRequired" [(ngModel)]="serviceProviderInfo.isLoginOTPRequired"
                      name="isLoginOTPRequired" type="checkbox" />
                    <label style="font-weight: normal;" for="isLoginOTPRequired">OTP Based Authentication</label>
                    <span></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label">Enable Pending Cases Reminder</label>
                <span class="desc"></span>
                  <div class="controls">
                  <div class="chiller_cb">
                  <input id="enablePendingCasesReminder" [(ngModel)]="serviceProviderInfo.enablePendingCasesReminder"
                                        name="enablePendingCasesReminder" type="checkbox" />
                  <label style="font-weight: normal;" for="enablePendingCasesReminder">Daily Reminder for Experts</label>
                  <span></span>
                  </div>
                </div>
              </div>
            </div>
            <!--START Expert Flows if Service provider Reading Center -->
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"
              *ngIf="serviceProviderInfo.type == 'SERVICE_READING_CENTER'">
              <div class=" form-group">
                <label class="form-label">Experts Review Catagory</label>
                <span class="desc"></span>
                <div class="controls">
                  <!-- 

                    <select [(ngModel)]="serviceProviderInfo.type" (change)="onProviderTypeChange($event.target.value)"
                    required class="form-select form-select-sm" #providerCategory="ngModel" id="providerCategory"
                    name="providerCategory">
                    <option *ngFor="let category of serviceProviderCategories | orderBy:'categoryName'"
                      [ngValue]="category.categoryId">{{category.categoryName}}</option>
                  </select>
                   -->
                  <select [(ngModel)]="serviceProviderInfo.expertReviewCategory" id="expertReviewCategory"
                    name="expertReviewCategory" #expertReviewCategory="ngModel" class="form-select form-select-sm" required
                    (change)="onExpertReviewCategoryChange($event.target.value)">
                    <option *ngFor="let category of expertReviewCategoryDropdown" [ngValue]="category.id">
                      {{category.itemName}}
                    </option>
                    <!-- #availableAIFlows="ngModel" [(ngModel)]="serviceProviderInfo.aiMode" -->
                  </select>
                </div>
              </div>
            </div>
            <!-- END Expert Flows if Service provider Reading Center  -->

            <!--start : enable treatment status -->
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"
            *ngIf="serviceProviderInfo.type == 'SERVICE_READING_CENTER'">
            <div class=" form-group">
              <label class="form-label">Treatment Status</label>
              <span class="desc">Allows RCM to enable/disable treatment status per user</span>
              <div class="controls">
                <div class="chiller_cb">
                <input id="enableTreatmentStatus" [(ngModel)]="serviceProviderInfo.enableTreatmentStatus"
                      name="enableTreatmentStatus" type="checkbox" />
                <label style="font-weight: normal;" for="enableTreatmentStatus">Enable treatment status in user creation</label>
                <span></span>
                </div>
              </div>
            </div>
            </div>
            <!--end : enable treatment status -->

            <!--start : enable Case Search -->
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <div class=" form-group">
              <label class="form-label">Enable Case Search</label>
              <div class="controls">
                <div class="chiller_cb">
                <input id="enableCaseSearch" [(ngModel)]="serviceProviderInfo.enableCaseSearch"
                      name="enableCaseSearch" type="checkbox" />
                <label style="font-weight: normal;" for="enableCaseSearch">Enable Case Search (MRN, Name, Mobile Number)</label>
                <span></span>
                </div>
              </div>
            </div>
            </div>
            <!--end : enable Case Search -->

            <div class="form-group text-center col-xs-12">
              <button type="button" style="margin:20px;margin-left: 10px;margin-right:10px;" uiSref="work"
                class="btn btn-info btn-raised" [awGoToStep]="{stepIndex: 1}"
                [disabled]="!providerInfoForm.form.valid || nameExists || emailExists || mobileExists || !defaultLanguage || !selectedMasterLanguageList || selectedMasterLanguageList.length==0">
                Next
                <span style="margin-left:10px;">
                  <i class="feather ft-chevron-right"></i>
                </span>
              </button>
            </div>
          </form>
        </aw-wizard-step>
        <aw-wizard-step awOptionalStep [stepId]="2" *ngIf="serviceProviderInfo.id==null" [stepTitle]="getTitle()"
          [navigationSymbol]="{ symbol: '2'}">
          <form #admininfoForm="ngForm" class="mTop30">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label" for="field-1">Title
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Salutation</span>
                <div class="controls">
                  <select [(ngModel)]="userInfo.title" class="form-select form-select-sm" #userTitle="ngModel" id="userTitle"
                    name="userTitle">
                    <option value="Dr.">Dr.</option>
                    <option value="Mr.">Mr.</option>
                    <option value="Mrs.">Mrs.</option>
                    <option value="Miss.">Miss.</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label" for="field-1">Gender
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Sex/Gender</span>
                <div class="controls">
                  <select [(ngModel)]="userInfo.gender" class="form-select form-select-sm" #userGender="ngModel" id="userGender"
                    name="userGender">
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
              <div class=" form-group">
                <label class="form-label" for="field-1">First Name
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">First Name</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="userInfo.firstName" #firstName="ngModel" name="firstName"  
                  pattern="^[a-zA-Z ]*"  id="firstName" class="form-control" placeholder="Enter first name here..." required />
                  <!-- <div [hidden]="firstName.valid || firstName.pristine" class="danger-text">
                    First name is required
                  </div> -->
                  <div *ngIf="firstName.errors && firstName.dirty" class="danger-text">
                    <div *ngIf="firstName.errors.required">
                      First Name is required 
                    </div>
                    <div *ngIf="firstName.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label" for="field-1">Last Name</label>
                <span class="desc">Last Name/Surname</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="userInfo.lastName" #lastName="ngModel" name="lastName" id="lastName"   
                  pattern="^[a-zA-Z ]*" class="form-control" placeholder="Enter last name here..." />
                  <!-- <div [hidden]="lastName.valid || lastName.pristine" class="danger-text">
                    Last name is required
                  </div> -->
                  <div *ngIf="lastName.errors && lastName.dirty" class="danger-text">
                    <div *ngIf="lastName.errors.required">
                      Last Name is required 
                    </div>
                    <div *ngIf="lastName.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
              <div class=" form-group">
                <label class="form-label" for="field-1">Email
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Email id for login & communication to admin user</span>
                <div class="controls">
                  <input autocomplete="off" type="email" (keyup)="validateUserEmailExists(admininfoForm)"
                    name="userEmail" id="userEmail" pattern="[a-zA-Z0-9_.+,-]{1,}@[a-zA-Z0-9.-]{2,}\.[a-zA-Z]{2,}"
                    #userEmail="ngModel" [(ngModel)]="userInfo.email" class="form-control"
                    placeholder="Enter email address here..." required />
                  <div *ngIf="userEmail.errors && userEmail.dirty" class="danger-text">
                    <div *ngIf="userEmail.errors.required">
                      Email is required
                    </div>
                    <div *ngIf="userEmail.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div>
                  <div *ngIf="userEmailExists" class="danger-text">
                    User email already exits
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label" for="field-1">Mobile
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Mobile number to communicate the admin user</span>
                <div class="controls">
                  <input type="text" (keyup)="validateUserMobileExists()" (keypress)="_keyPress($event)"
                    [(ngModel)]="userInfo.phoneNo" required ng-pattern="/^[0-9]*$/" #userMobile="ngModel"
                    name="userMobile" id="userMobile" class="form-control" placeholder="Enter mobile number here..."
                    required />
                  <div [hidden]="userMobile.valid || userMobile.pristine" class="danger-text">
                    Mobile number is required
                  </div>
                  <div *ngIf="userMobileExists" class="danger-text">
                    User mobile already exits
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
              <div class=" form-group">
                <label class="form-label" for="field-1">Password
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Temporary password to be given to service provider admin</span>
                <div class="controls">
                  <input class="form-control" [(ngModel)]="userInfo.password" #password="ngModel" required id="password"
                    name="password" type="password" placeholder="Enter password here..."
                    (keyup)="isStrongPassword = checkStrongPassword(userInfo.password)">
                  <!-- start : strong password check-->
                  <div>
                    <span *ngIf="userInfo.password && userInfo.password.length>0 && isStrongPassword"
                      style="background-color:#27c24c;color:white;padding:2px;padding-left: 5px;padding-right: 5px;"><i
                        class="fa fa-check-circle">&nbsp;</i>Strong Password</span>
                    <span *ngIf="userInfo.password && userInfo.password.length>0 && !isStrongPassword"
                      style="background-color:#f05050;color:white;padding:2px;padding-left: 5px;padding-right: 5px;"><i
                        class="fa fa-times-circle">&nbsp;</i>Weak Password</span>
                    <span class="pull-right" style="cursor: pointer;"><a
                        (click)="showPasswordPolicy = !showPasswordPolicy"><span
                          *ngIf="!showPasswordPolicy">Show</span><span *ngIf="showPasswordPolicy">Hide</span> password
                        policy</a></span>
                  </div>
                  <div *ngIf="showPasswordPolicy">
                    <span style="font-style: italic;">
                      Password must contain
                      <ol>
                        <li>Minimum 8 letters</li>
                        <li>At least 1 uppercase character</li>
                        <li>At least 1 lowercase character</li>
                        <li>At least 1 number</li>
                        <li>At least 1 special character</li>
                      </ol>
                    </span>
                  </div>
                  <!-- end : strong password check-->
                  <div [hidden]="password.valid || password.pristine" class="danger-text">
                    Password is required
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label" for="field-1">Confirm Password
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Repeat the password entered</span>
                <div class="controls">
                  <input class="form-control" [(ngModel)]="confirmPassword" #confirmPasswordText="ngModel" required
                    id="confirmPassword" type="password" name="confirmPassword"
                    placeholder="Enter confirm password here...">
                  <div [hidden]="confirmPasswordText.valid || confirmPasswordText.pristine" class="danger-text">
                    Confirm Password is required
                  </div>
                  <div *ngIf="userInfo.password != confirmPassword && confirmPasswordText.dirty" class="danger-text">
                    Password and confirm password should match
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
              <div class=" form-group">
                <label class="form-label" for="field-1">Address Line1
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Flat/Door/Block No</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="userInfo.address.addressLine1" #addressLine1="ngModel"  
                  pattern=".*[a-zA-Z0-9].*" name="addressLine1" id="userAddressLine1" class="form-control"
                    placeholder="Enter address line1 here..." required />
                  <!-- <div [hidden]="addressLine1.valid || addressLine1.pristine" class="danger-text">
                    Address Line1 is required
                  </div> -->
                  <div *ngIf="addressLine1.errors && addressLine1.dirty" class="danger-text">
                    <div *ngIf="addressLine1.errors.required">
                      Address Line1 is required 
                    </div>
                    <div *ngIf="addressLine1.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div> 
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label" for="field-1">AddressLine 2
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Area/Locality</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="userInfo.address.addressLine2" #addressLine2="ngModel"   
                  pattern=".*[a-zA-Z0-9].*"  name="addressLine2" id="useAaddressLine2" class="form-control"
                    placeholder="Enter address line2 here..." required />
                  <!-- <div [hidden]="addressLine2.valid || addressLine2.pristine" class="danger-text">
                    Address Line2 is required
                  </div> -->
                  <div *ngIf="addressLine2.errors && addressLine2.dirty" class="danger-text">
                    <div *ngIf="addressLine2.errors.required">
                      Address Line2 is required 
                    </div>
                    <div *ngIf="addressLine2.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
              <div class=" form-group">
                <label class="form-label" for="field-1">District
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">District/City/Town</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="userInfo.address.district" #district="ngModel" name="district" 
                  pattern=".*[a-zA-Z].*"  id="userDistrict" class="form-control" placeholder="Enter district here..." required />
                  <!-- <div [hidden]="district.valid || district.pristine" class="danger-text">
                    District is required
                  </div> -->
                  <div *ngIf="district.errors && district.dirty" class="danger-text">
                    <div *ngIf="district.errors.required">
                      District is required 
                    </div>
                    <div *ngIf="district.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label" for="field-1">State
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">State</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="userInfo.address.state" #state="ngModel" name="state" id="userState"  
                  pattern="^[a-zA-Z ]*" class="form-control" placeholder="Enter state here..." required />
                  <!-- <div [hidden]="state.valid || state.pristine" class="danger-text">
                    State is required
                  </div> -->
                  <div *ngIf="state.errors && state.dirty" class="danger-text">
                    <div *ngIf="state.errors.required">
                       State is required
                    </div>
                    <div *ngIf="state.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
              <div class=" form-group">
                <label class="form-label" for="field-1">Pincode
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Pincode</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="userInfo.address.zipcode" #pincode="ngModel" name="pincode"
                  pattern="^[0-9 ]*" id="userPincode" class="form-control" placeholder="Enter pincode here..." required />
                  <!-- <div [hidden]="pincode.valid || pincode.pristine" class="danger-text">
                    Pincode is required
                  </div> -->
                  <div *ngIf="pincode.errors && pincode.dirty" class="danger-text">
                    <div *ngIf="pincode.errors.required">
                      Pincode is required
                    </div>
                    <div *ngIf="pincode.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label" for="field-1">Country
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Country</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="userInfo.address.country" #country="ngModel" name="country"  
                  pattern="^[a-zA-Z ]*" id="userCountry" class="form-control" placeholder="Enter country here..." required />
                  <!-- <div [hidden]="country.valid || country.pristine" class="danger-text">
                    Country name is required
                  </div> -->
                  <div *ngIf="country.errors && country.dirty" class="danger-text">
                    <div *ngIf="country.errors.required">
                      Country is required
                    </div>
                    <div *ngIf="country.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group text-center space-20" style="margin-top: 15px;">
              <button uiSref="personal" type="button" class="btn btn-raised btn-secondary mr-1"
                style="margin:20px;margin-left: 10px;margin-right:10px;" awPreviousStep>
                <span style="margin-right:10px;">
                  <i class="feather ft-chevron-left"></i>
                </span> Previous</button>
              <button type="button" style="margin:20px;margin-left: 10px;margin-right:10px;" uiSref="work"
                class="btn btn-info btn-raised" [awGoToStep]="{stepIndex: 2}" [disabled]="!admininfoForm.form.valid || confirmPassword != userInfo.password || !isStrongPassword ||
                 userEmailExists || userMobileExists">
                Next
                <span style="margin-left:10px;">
                  <i class="feather ft-chevron-right"></i>
                </span>
              </button>
            </div>
          </form>
        </aw-wizard-step>
        <aw-wizard-step awOptionalStep [stepId]="3" [stepTitle]="'Review & Complete'"
          [navigationSymbol]="{ symbol: serviceProviderInfo.id==null?'3':'2'}">
          <div
            [ngClass]="{'col-xs-12 col-sm-12 col-md-12 col-lg-12 mTop15':serviceProviderInfo.id!=null,'col-xs-12 col-sm-12 col-md-6 col-lg-6 mTop15':serviceProviderInfo.id==null}">
            <div class="table-responsive">
              <table class="table borderless">
                <tbody>
                  <tr style="background:#fbfbfb;">
                    <td colspan="2">Service provider Details</td>
                  </tr>
                  <tr>
                    <td>Acocunt Name</td>
                    <td>{{serviceProviderInfo.name}}</td>
                  </tr>
                  <tr>
                    <td>Category</td>
                    <td>{{getProviderType(serviceProviderInfo.type)}}</td>
                  </tr>
                  <tr *ngIf="serviceProviderInfo.type == 'SERVICE_AI'">
                    <td>AI Modes</td>
                    <td>
                      <span *ngFor="let item of serviceProviderInfo.aiMode; let isLast=last">
                        {{item.itemName}}{{isLast ? '' : ', '}}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>Associated accounts</td>
                    <td>
                      <span *ngFor="let item of serviceProviderInfo.accountIds; let isLast=last">
                        {{item.itemName}}{{isLast ? '' : ', '}}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>Contact Email</td>
                    <td>{{serviceProviderInfo.email}}</td>
                  </tr>
                  <tr>
                    <td>Contact Mobile</td>
                    <td>{{serviceProviderInfo.phone}}</td>
                  </tr>
                  <tr>
                    <td>Address Line1</td>
                    <td>{{serviceProviderInfo.address.addressLine1}}</td>
                  </tr>
                  <tr>
                    <td>Address Line2</td>
                    <td>{{serviceProviderInfo.address.addressLine2}}</td>
                  </tr>
                  <tr>
                    <td>District</td>
                    <td>{{serviceProviderInfo.address.district}}</td>
                  </tr>
                  <tr>
                    <td>State</td>
                    <td>{{serviceProviderInfo.address.state}}</td>
                  </tr>
                  <tr>
                    <td>Pincode</td>
                    <td>{{serviceProviderInfo.address.zipcode}}</td>
                  </tr>
                  <tr>
                    <td>Country</td>
                    <td>{{serviceProviderInfo.address.country}}</td>
                  </tr>
                  <tr>
                    <td>Language</td>
                    <td>{{getLanguage()}}</td>
                  </tr>
                  <tr>
                    <td>Timezone</td>
                    <td>{{getTimeZone()}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 mTop15" *ngIf="serviceProviderInfo.id==null">
            <div class="table-responsive">
              <table class="table borderless">
                <tbody>
                  <tr style="background:#fbfbfb;">
                    <td colspan="2">User Details</td>
                  </tr>
                  <tr>
                    <td>User Name</td>
                    <td>{{userInfo.title}}{{userInfo.firstName}} {{userInfo.lastName}}</td>
                  </tr>
                  <tr>
                    <td>Gender</td>
                    <td>{{userInfo.gender}}</td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>{{userInfo.email}}</td>
                  </tr>
                  <tr>
                    <td>Mobile</td>
                    <td>{{userInfo.phoneNo}}</td>
                  </tr>
                  <tr>
                    <td>Password</td>
                    <td>
                      <span *ngIf="showPassword">{{userInfo.password}}</span>
                      <span *ngIf="!showPassword">**********</span>
                      <i class="fa fa-eye float-right" style="cursor:pointer;font-size: 17px;color: #7ac0e4;"
                        *ngIf="showPassword" (click)="showPassword = ! showPassword"></i>
                      <i class="fa fa-eye-slash float-right" style="cursor:pointer;font-size: 17px;color: #7ac0e4;"
                        *ngIf="!showPassword" (click)="showPassword = ! showPassword"></i>
                    </td>
                  </tr>
                  <tr>
                    <td>Address Line1</td>
                    <td>{{userInfo.address.addressLine1}}</td>
                  </tr>
                  <tr>
                    <td>Address Line2</td>
                    <td>{{userInfo.address.addressLine2}}</td>
                  </tr>
                  <tr>
                    <td>District</td>
                    <td>{{userInfo.address.district}}</td>
                  </tr>
                  <tr>
                    <td>State</td>
                    <td>{{userInfo.address.state}}</td>
                  </tr>
                  <tr>
                    <td>Pincode</td>
                    <td>{{userInfo.address.zipcode}}</td>
                  </tr>
                  <tr>
                    <td>Country</td>
                    <td>{{userInfo.address.country}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="form-group col-xs-12 text-center space-20" style="margin-top: 15px;">
            <button uiSref="personal" type="button" class="btn btn-raised btn-secondary mr-1"
              style="margin:20px;margin-left: 10px;margin-right:10px;" awPreviousStep>
              <span style="margin-right:10px;">
                <i class="feather ft-chevron-left"></i>
              </span> Previous</button>
            <button type="button" (click)="onComplete()" style="margin:20px;margin-left: 10px;margin-right:10px;"
              uiSref="work" class="btn btn-info btn-raised">
              Submit
              <span style="margin-left:10px;">
                <i class="feather ft-chevron-right"></i>
              </span>
            </button>
          </div>
        </aw-wizard-step>
      </aw-wizard>
    </ng-template>
  </div>
</div>